export default __webpack_public_path__ + "static/media/envelop.7e29f69a.svg";